import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "counter", "dutyBlockSection", "category", "overflowMode"]
  static values = {
    selectedLabel: { type: String, default: "geselecteerd" }
  }

  connect() {
    this.updateAllCounters()
    this.updateDutyBlockVisibility()
  }

  selectAll(event) {
    const category = event.currentTarget.dataset.category
    this.checkboxTargets
      .filter(cb => cb.dataset.category === category)
      .forEach(cb => { cb.checked = true })
    this.updateCounterForCategory(category)
    if (category === "diensten") this.updateDutyBlockVisibility()
  }

  deselectAll(event) {
    const category = event.currentTarget.dataset.category
    this.checkboxTargets
      .filter(cb => cb.dataset.category === category)
      .forEach(cb => { cb.checked = false })
    this.updateCounterForCategory(category)
    if (category === "diensten") this.updateDutyBlockVisibility()
  }

  updateCounter(event) {
    const category = event.target.dataset.category
    this.updateCounterForCategory(category)
    if (category === "diensten") this.updateDutyBlockVisibility()
  }

  toggleOverflowRow(event) {
    const checkbox = event.target
    const row = checkbox.closest("[class*='flex items-center gap-3']")
    if (!row) return
    const select = row.querySelector("select")
    if (!select) return
    if (checkbox.checked) {
      select.classList.remove("opacity-40", "pointer-events-none")
    } else {
      select.classList.add("opacity-40", "pointer-events-none")
    }
  }

  updateAllCounters() {
    const categories = new Set(
      this.checkboxTargets.map(cb => cb.dataset.category)
    )
    categories.forEach(cat => this.updateCounterForCategory(cat))
  }

  updateCounterForCategory(category) {
    const checkboxes = this.checkboxTargets.filter(cb => cb.dataset.category === category)
    const checked = checkboxes.filter(cb => cb.checked).length
    const total = checkboxes.length

    const counter = this.counterTargets.find(el => el.dataset.category === category)
    if (counter) {
      counter.textContent = `(${checked}/${total} ${this.selectedLabelValue})`
    }
  }

  updateDutyBlockVisibility() {
    if (!this.hasDutyBlockSectionTarget) return

    const dienstenChecked = this.checkboxTargets
      .filter(cb => cb.dataset.category === "diensten")
      .some(cb => cb.checked)

    this.dutyBlockSectionTarget.style.display = dienstenChecked ? "" : "none"
  }
}
